import { CabifyProcessStateType } from 'src/core/models'

const cabifyProcessState: CabifyProcessStateType = {
  fleetState: {
    loading: false,
    data: null,
    successCreate: false,
    successDelete: false,
    error: null
  },
  calculateFootprint: {
    loading: false,
    results: null,
    error: null,
  },
  downloadFile: {
    loading: false,
    fileUrl: null,
    error: null
  }
}

export { cabifyProcessState as initialState }
